<template>
  <div class="page">
    <div class="container left">
      <div :class="{'scaled-container': !isShowCardGroupInfo, 'unscaled-scaled-container': isShowCardGroupInfo}">
        <div class="form" v-if="isShowSearch">
          <el-form :inline="true" :model="form" :rules="formRules" ref="formRef" size="small">
            <div ref="tableSearch" class="table-search" :class="isCollapse && isShowCollapseBtn ? 'is-collapse':''">
              <slot name="tableSearch"/>
            </div>
            <span class="collapse-button" v-if="isShowCollapseBtn" @click="isCollapse=!isCollapse">
          <i :class="isCollapse ? 'el-icon-arrow-down'  :'el-icon-arrow-up'"></i>
          <span>{{ $t(isCollapse ? 'text.expand' : 'text.collapse') }}</span>
        </span>
            <div class="item_button">
              <el-form-item style="margin-bottom: 0">
                <el-button :loading="loading" type="primary" @click="onSubmit">
                  {{ $t('text.search') }}
                </el-button>
              </el-form-item>
              <el-form-item style="margin-bottom: 0">
                <el-button :loading="loading" type="primary" @click="onReset">
                  {{ $t('text.reset') }}
                </el-button>
              </el-form-item>
            </div>

            <slot name="buttonArea"/>
          </el-form>

          <div>
            <slot name="pageHeader"></slot>
          </div>
        </div>
        <div class="child">
          <el-table :data="list"
                    v-loading="loading"
                    :row-style="{ height: '40px' }"
                    :cell-style="{ padding: '2px 0' }"
                    @sort-change="sortChange"
                    :default-sort="sortInfo"
                    highlight-current-row
                    style="border-right:  1px solid #dce4ea"
                    @selection-change="handleSelectionChange"
          >
            <slot name="tableColumn"/>
          </el-table>
        </div>
        <div class="pagination">
          <el-pagination @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         :current-page.sync="currentPage"
                         :page-sizes="[30, 100]"
                         :page-size="pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="total">
          </el-pagination>
        </div>
      </div>
      <div class="parent-container" v-show="!isShowCardGroupInfo">
        <el-button
            type="primary"
            size="mini"
            class="custom-button"
            @click="showCardGroupInfo"
        >
          {{ $t('text.cardGroupAbbreviation') }}
        </el-button>
      </div>
      <div class="parent-demo right">
        <CardGroupConfigList
            v-if="isShowCardGroupInfo"
            :show.sync="isShowCardGroupInfo"
            :cardGroupList="cardGroupList"
            @refresh-list="refreshCardGroupList"
            @refresh-card-group="selectCardGroup"
            @refresh-card-card-list="refreshCrdList"
        ></CardGroupConfigList>
      </div>
    </div>
  </div>
</template>

<script>
import CardGroupConfigList from "./CardGroupConfigList.vue";

export default {
  name: "page",
  components: { CardGroupConfigList: CardGroupConfigList},
  data() {
    return {
      list: [],
      currentPage: 1,
      pageSize: 30,
      sort: 1,
      total: 0,
      loading: false,
      isShowCollapseBtn: false,
      isShowCardGroupInfo: false,
      isCollapse: true,
      cardGroupList:[],
    };
  },
  props: {
    url: {
      type: String,
      default: ""
    },
    sortInfo: {
      type: Object,
      default: () => {
      }
    },
    form: {
      type: Object,
      default: null
    },
    isShowSearch: {
      type: Boolean,
      default: true
    },
    formRules: {
      type: Object,
      default: null
    },
  },
  activated() {
    if (this.$store.state.isKeepLive) {
      this.list = [];
      this.currentPage = 1;
      this.pageSize = 30;
      this.tableChange(this.form);
    }
    this.handleCollapseBtn()
    window.addEventListener('resize', this.handleCollapseBtn);
  },
  deactivated() {
    window.removeEventListener('resize', this.handleCollapseBtn);
  },
  methods: {
    //修改每页条数触发
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.tableChange(this.form);
    },
    //翻页触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.tableChange(this.form);
    },
    //更新table数据
    tableChange(params) {
      let param = {};
      this.loading = true;
      for (let key in params) {
        let value = params[key];
        if (value !== "" && value !== null) {
          param[key] = value;
        }
      }

      param.size = this.pageSize;
      param.page = this.currentPage;

      this.$axios
          .get(this.url, {
            params: param,
            timeout: 5 * 60 * 1000
          })
          .then((res) => {
            this.loading = false;
            if (res.code === 200) {
              this.total = parseInt(res.data.total);
              this.list = res.data.list;
              // if (Array.isArray(res.data)) {
              //   // 無分頁
              //   this.list = res.data;
              //   this.total = res.data.length;
              // } else {
              //   // 有分頁
              //   this.total = parseInt(res.data.total);
              //   this.list = res.data.list;
              // }
              // this.$notify.success({
              //   title: this.$t("text.prompt"),
              //   message: '已查询到 ' + this.total + ' 笔资料'
              // });
            }
          })
          .catch(() => {
            this.loading = false;
            this.$notify.error({
              title: this.$t('text.prompt'),
              message: this.$t('message.queryFailed')
            });
          });
    },
    handleSelectionChange(val) {
      this.$emit("select-data", val);
    },
    onSubmit() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.currentPage = 1;
          this.tableChange(this.form);
          //如果父组件里有统计方法，则执行统计
          if (this.$parent.countAmount) {
            this.$parent.countAmount();
          }
        } else {
          return false;
        }
      });
    },
    onReset() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = "";
      });
      this.form.sortType = "00";
      this.$refs["formRef"].resetFields();
      this.$emit("reset");
      this.onSubmit();
    },
    sortChange(column) {
      let params = {
        ...this.form,
        sortType: column.order === "ascending" ? "01" : "00"
      };
      this.tableChange(params);
    },
    handleCollapseBtn() {
      if (this.$refs.tableSearch.lastChild) {
        const parentHeight = this.$refs.tableSearch.scrollHeight
        const childHeight = this.$refs.tableSearch.lastChild.scrollHeight
        if (parentHeight > childHeight * 2) {
          this.isShowCollapseBtn = true
        } else {
          this.isShowCollapseBtn = false
        }
      }
    },
    showCardGroupInfo(){
      this.loading = true;
      this.tableChange(this.form);
      this.fetchCardGroupList();
      this.isShowCardGroupInfo = true;
    },
    fetchCardGroupList() {
      this.loading = true;
      this.$axios.get("/card-group/selectList", { params: {} }).then((res) => {
        if (res.code === 200) {
          this.refreshCardGroupList(res.data.list);
          this.loading = false;
        }
      })
      this.loading = false;
    },
    refreshCardGroupList(newVal) {
      this.cardGroupList = newVal;
    },
    selectCardGroup(){
      this.$emit('refresh-card-group');
    },
    refreshCrdList(){
      this.tableChange(this.form);
    }
  },
  created() {
    // this.currentPage = 1
    // this.pageSize = 30
    // this.tableChange(this.form)
  }
};
</script>

<style scoped lang="scss">
.page {
  background: transparent;
  text-align: left;
  border: 1px solid #dce4ea;
}

.form {
  border-bottom: 1px solid #dce4ea;
  padding: 10px;
  background-color: #ffffff;
}

.item_button {
  display: initial;
}

.table-search {
  &.is-collapse {
    display: block;
    height: 50px;
    overflow: hidden;
  }
}

.collapse-button {
  cursor: pointer;
  font-size: 14px;
  margin: 0 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

// 设置成行
.container {
  display: flex; /* 开启弹性布局 */
  flex-direction: row; /* 默认横向排列 */
  width: 100%; /* 占满可用宽度 */
}

.left, .right {
  box-sizing: border-box;
  word-break: break-word; /* 防止文字内容过长导致溢出重叠 */
}


// 未开启卡组
.scaled-container {
  background-color: #f5f5f5; /* 示例背景色 */
  transform-origin: top left; /* 设置缩放基点 */
  transition: transform 0.3s ease; /* 动画过渡效果，页面缩放更平滑 */
  width: 95%; /* 占满可用宽度 */
}
// 开启卡组
.unscaled-scaled-container{
  background-color: #f5f5f5; /* 示例背景色 */
  transform-origin: top left; /* 设置缩放基点 */
  transition: transform 0.3s ease; /* 动画过渡效果，页面缩放更平滑 */
  width: 100%; /* 占满可用宽度 */
  max-width: 60%;
}

// 卡组按钮
.custom-button {
  z-index: 100; /* 设置优先级 */
  height: 100%; /* 父容器全高 */
}
.parent-container {
  display: flex; /* 开启弹性布局 */
  justify-content: flex-end; /* 子元素向右对齐 */
  align-items: center; /* 垂直方向居中 */
  height: 75%; /* 父容器全高 */
  position: fixed; /* 固定在视口 */
  right: 5px; /* 距离页面右侧10px，可根据需求调整 */
  z-index: 1000; /* 设置 z-index，避免被其他元素遮挡 */
  transform: translate(-20%, 10%);
}

.parent-demo {
  display: flex; /* 开启弹性布局 */
  position: fixed; /* 固定在视口 */
  right: 5px; /* 距离页面右侧10px，可根据需求调整 */
  padding-left: 20px; /* 距离页面右侧10px，可根据需求调整 */
  z-index: 1000; /* 设置 z-index，避免被其他元素遮挡 */
  max-height: 88%; /* 最大高度为视窗高度的90% */
  max-width: 40%; /* 最大宽度为视窗宽度的50% */
  min-width: 30%; /* 最大宽度为视窗宽度的50% */
  overflow-y: auto; /* 超出高度时显示垂直滚动条 */
  background-color: #fff; /* 设置背景色为白色 */
  border: 1px solid #dce4ea; /* 添加边框 */
}

@media (max-width: 1910px) {
  .parent-demo {
    width: 35%; /* 让左右部分在小屏幕下垂直排列，避免狭窄的宽度重叠 */
    margin-bottom: 10px; /* 增加间距 */
    max-height: 82%; /* 最大高度为视窗高度的90% */
  }
}

@media (max-width: 1850px) {
  .parent-demo {
    width: 3%; /* 让左右部分在小屏幕下垂直排列，避免狭窄的宽度重叠 */
    margin-bottom: 10px; /* 增加间距 */
    max-height: 87%; /* 最大高度为视窗高度的90% */
  }
}

@media (max-width: 1720px) {
  .parent-demo {
    width: 36%; /* 让左右部分在小屏幕下垂直排列，避免狭窄的宽度重叠 */
    margin-bottom: 10px; /* 增加间距 */
    max-height: 86%; /* 最大高度为视窗高度的90% */
  }
}

@media (max-width: 1620px) {
  .parent-demo {
    width: 36%; /* 让左右部分在小屏幕下垂直排列，避免狭窄的宽度重叠 */
    margin-bottom: 10px; /* 增加间距 */
    max-height: 84%; /* 最大高度为视窗高度的90% */
  }
}

@media (max-width: 1520px) {
  .parent-demo {
    width: 34.7%; /* 让左右部分在小屏幕下垂直排列，避免狭窄的宽度重叠 */
    margin-bottom: 10px; /* 增加间距 */
    max-height: 82%; /* 最大高度为视窗高度的90% */
  }
}

@media (max-width: 1420px) {
  .parent-demo {
    width: 34%; /* 让左右部分在小屏幕下垂直排列，避免狭窄的宽度重叠 */
    margin-bottom: 10px; /* 增加间距 */
    max-height: 82%; /* 最大高度为视窗高度的90% */
  }
}
</style>
